module.exports = __webpack_public_path__ + "static/media/78.c02c989b.jpg";